import * as React from "react"
import styled from "styled-components"
import { Colors } from "../../theme/"
import Text from "../../components/text"
import SeeMoreBox from "../see-more-box"
import Column from "../column"
import Box from "../box"

interface Props {
  description: string
}

export const formatDescription = (text: string) =>
  text.split("\\n").map((item, index) => (
    <span key={`about-${index}`}>
      {item}
      <br />
    </span>
  ))

const DesText = styled.p`
  font-family: "Comfortaa", cursive !important;
  font-size: 18px;
  margin-bottom: 0.5em;
  color: ${Colors.darkGrey};
  white-space: pre-wrap;
  line-height: 1.4;
`

const HeadingH2 = styled.h2`
  text-decoration: none;
  margin-bottom: 8px;
  color: #3c4240;
  font-size: 32px;
  font-weight: 600;
`

const SingleListingAboutSection = ({ description }: Props) => {
  const isDescShort = Boolean(description) && description.length < 10
  return (
    <Box flexDirection="column" mb={[5]}>
      <HeadingH2 fontSize={32} fontWeight={600} color={Colors.darkGrey} mb="8px">
        About
      </HeadingH2>
      <Column>
        {isDescShort ? (
          <DesText>{formatDescription(description)}</DesText>
        ) : (
          <>
            {description && description.length > 0 && (
              <SeeMoreBox collapsedHeight={78} hideSeeMoreButton={isDescShort}>
                <DesText>{formatDescription(description)}</DesText>
              </SeeMoreBox>
            )}
          </>
        )}
      </Column>
    </Box>
  )
}

export default SingleListingAboutSection
